<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBPriceItemForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBPriceItemList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBPriceItemForm from './Form.vue'

export default {
  components: {
    EXSBPriceItemForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbpriceitem/update/isLoading',
      error: 'exsbpriceitem/update/error',
      deleteError: 'exsbpriceitem/del/error',
      deleteLoading: 'exsbpriceitem/del/isLoading',
      created: 'exsbpriceitem/create/created',
      deleted: 'exsbpriceitem/del/deleted',
      retrieved: 'exsbpriceitem/update/retrieved',
      updated: 'exsbpriceitem/update/updated',
      violations: 'exsbpriceitem/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBPriceItemList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbpriceitem/create/reset',
      deleteItem: 'exsbpriceitem/del/del',
      delReset: 'exsbpriceitem/del/reset',
      retrieve: 'exsbpriceitem/update/retrieve',
      updateReset: 'exsbpriceitem/update/reset',
      update: 'exsbpriceitem/update/update',
      updateRetrieved: 'exsbpriceitem/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbpriceitem ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
